import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  ref: "teamExpandWrapper",
  class: "u-row o-brokerTeam__hideBrokers"
}
const _hoisted_2 = { class: "u-col-12 md:u-offset-1 md:u-col-10" }
const _hoisted_3 = {
  key: "info",
  class: "o-panel o-panel--spacedChildrenLarge"
}
const _hoisted_4 = {
  key: 0,
  class: "a-paragraph o-subPanel--spacedChildrenSmall"
}
const _hoisted_5 = {
  "data-aspect": "16/9",
  class: "a-video",
  controls: "",
  autoplay: "",
  disablePictureInPicture: "",
  controlsList: "nodownload noremoteplayback noplaybackrate"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "o-buttons o-subPanel__actions" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = {
  key: "form",
  class: "o-panel o-panel--spacedChildrenLarge"
}
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "o-fields" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "o-buttons o-subPanel__actions" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "m-button__text" }, "Tilbage", -1 /* HOISTED */)
const _hoisted_16 = ["textContent"]
const _hoisted_17 = {
  key: "form2",
  class: "o-subPanel o-subPanel--spacedChildrenLarge"
}
const _hoisted_18 = ["textContent"]
const _hoisted_19 = { class: "a-confirmationNotice" }
const _hoisted_20 = { class: "a-confirmationNotice__checkmark" }
const _hoisted_21 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oEmployeeShopCard = _resolveComponent("oEmployeeShopCard")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_oEmployeeShopPanelCard = _resolveComponent("oEmployeeShopPanelCard")!
  const _component_m_textarea = _resolveComponent("m-textarea")!
  const _component_m_input = _resolveComponent("m-input")!
  const _component_portal = _resolveComponent("portal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref: "teamList",
        class: _normalizeClass(["o-brokerTeam__brokerList", {
                    'o-brokerTeam__brokerList--lessThanFour': $options.lessThanFour && $props.isBuyerAdviceTeam,
                    ' o-brokerTeam__brokerList--noHeadline': $props.isBuyerAdviceTeam
                }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.employees, (employee, index) => {
          return (_openBlock(), _createBlock(_component_oEmployeeShopCard, {
            key: index,
            employee: employee,
            "cta-text": $props.texts.contactCtaText,
            onClicked: $options.onClickChild
          }, null, 8 /* PROPS */, ["employee", "cta-text", "onClicked"]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 2 /* CLASS */)
    ]),
    ($data.isTeamListExpandable)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["o-brokerTeam__expander", {'o-brokerTeam__expander--yellow': $props.isBuyerAdviceTeam}])
        }, [
          _createElementVNode("button", {
            ref: "teamExpandButton",
            type: "button",
            class: "o-brokerTeam__expanderButton",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.expand && $options.expand(...args)))
          }, [
            _createVNode(_component_a_icon, { name: "expand_more" })
          ], 512 /* NEED_PATCH */)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    ($options.isVisible && $props.consent.id)
      ? (_openBlock(), _createBlock(_component_portal, {
          key: 1,
          to: "modal"
        }, {
          default: _withCtx(() => [
            _createVNode(_Transition, {
              name: `o-panel--${$data.currentDirection}`
            }, {
              default: _withCtx(() => [
                (_ctx.currentPanel === `info-${$props.isBuyerAdviceTeam ? 'buyerAdvice' : 'broker'}`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_oEmployeeShopPanelCard, { employee: $data.selectedEmployee }, null, 8 /* PROPS */, ["employee"]),
                      ($data.selectedEmployee.videoUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("video", _hoisted_5, [
                              _createElementVNode("source", {
                                src: $data.selectedEmployee.videoUrl,
                                type: "video/mp4"
                              }, null, 8 /* PROPS */, _hoisted_6)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      ($data.selectedEmployee.description)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "a-paragraph o-subPanel--spacedChildrenSmall",
                            innerHTML: $data.selectedEmployee.description
                          }, null, 8 /* PROPS */, _hoisted_7))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "m-button m-button--outlined",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.nextPanel('form')))
                        }, [
                          _createElementVNode("span", {
                            class: "m-button__text",
                            textContent: _toDisplayString($props.texts.contactCtaText)
                          }, null, 8 /* PROPS */, _hoisted_9)
                        ])
                      ])
                    ]))
                  : (_ctx.currentPanel === `form-${$props.isBuyerAdviceTeam ? 'buyerAdvice' : 'broker'}`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_Transition, {
                          name: "fade",
                          mode: "out-in"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.currentSubPanel === 1)
                              ? (_openBlock(), _createElementBlock("form", {
                                  key: "form1",
                                  class: "o-subPanel o-subPanel--spacedChildrenLarge",
                                  onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($options.onSubmit && $options.onSubmit(...args)), ["prevent"]))
                                }, [
                                  _createVNode(_component_oEmployeeShopPanelCard, { employee: $data.selectedEmployee }, null, 8 /* PROPS */, ["employee"]),
                                  _createElementVNode("p", {
                                    class: "a-paragraph o-subpanel__headline",
                                    textContent: _toDisplayString($props.texts.formHeadline)
                                  }, null, 8 /* PROPS */, _hoisted_11),
                                  _createElementVNode("div", _hoisted_12, [
                                    _createVNode(_component_m_textarea, {
                                      modelValue: $data.form.message,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.form.message) = $event)),
                                      class: "o-fields__field",
                                      error: $data.errors.message,
                                      label: `${$props.texts.form.messageLabel}*`
                                    }, null, 8 /* PROPS */, ["modelValue", "error", "label"]),
                                    _createVNode(_component_m_input, {
                                      modelValue: $data.form.name,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.form.name) = $event)),
                                      class: "o-fields__field",
                                      autocomplete: 'name',
                                      error: $data.errors.name,
                                      label: `${$props.texts.form.nameLabel}*`
                                    }, null, 8 /* PROPS */, ["modelValue", "error", "label"]),
                                    _createVNode(_component_m_input, {
                                      modelValue: $data.form.mail,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.form.mail) = $event)),
                                      class: "o-fields__field",
                                      autocomplete: 'email',
                                      error: $data.errors.mail,
                                      label: `${$props.texts.form.mailLabel}*`
                                    }, null, 8 /* PROPS */, ["modelValue", "error", "label"]),
                                    _createVNode(_component_m_input, {
                                      modelValue: $data.form.phone,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.form.phone) = $event)),
                                      class: "o-fields__field",
                                      error: $data.errors.phone,
                                      autocomplete: 'tel',
                                      label: `${$props.texts.form.phoneLabel}*`
                                    }, null, 8 /* PROPS */, ["modelValue", "error", "label"]),
                                    ($props.consent)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "a-small a-small--allowBreak o-fields__field",
                                          innerHTML: $props.consent.purposeText
                                        }, null, 8 /* PROPS */, _hoisted_13))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_14, [
                                    (!_ctx.fixedPanel)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "m-button m-button--transparent",
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.previousPanel('info')))
                                        }, [
                                          _createVNode(_component_a_icon, {
                                            class: "m-button__icon",
                                            name: "arrow_back"
                                          }),
                                          _hoisted_15
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    _createElementVNode("button", {
                                      type: "submit",
                                      class: _normalizeClass(["m-button", { isLoading: $data.isLoading }])
                                    }, [
                                      _createElementVNode("span", {
                                        class: "m-button__text",
                                        textContent: _toDisplayString($props.texts.formSendButtonText)
                                      }, null, 8 /* PROPS */, _hoisted_16)
                                    ], 2 /* CLASS */)
                                  ])
                                ], 32 /* NEED_HYDRATION */))
                              : (_ctx.currentSubPanel === 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createVNode(_component_oEmployeeShopPanelCard, { employee: $data.selectedEmployee }, null, 8 /* PROPS */, ["employee"]),
                                    _createElementVNode("h2", {
                                      class: "a-heading2 o-panel__title",
                                      textContent: _toDisplayString($props.texts.formReceiptHeading)
                                    }, null, 8 /* PROPS */, _hoisted_18),
                                    _createElementVNode("div", _hoisted_19, [
                                      _createElementVNode("div", _hoisted_20, [
                                        _createVNode(_component_a_icon, { name: "check" })
                                      ]),
                                      _createElementVNode("span", {
                                        class: "a-label",
                                        textContent: _toDisplayString($props.texts.formReceiptBodyText)
                                      }, null, 8 /* PROPS */, _hoisted_21)
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true)
                          ], undefined, true),
                          _: 1 /* STABLE */
                        })
                      ]))
                    : _createCommentVNode("v-if", true)
              ], undefined, true),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["name"])
          ], undefined, true),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}